import React, { useEffect, useState } from 'react'
import './index.less'
import { useAppDispatch as _useAppDispatch, useAppSelector } from '@/hooks'
import Rhyme from '@/components/Compare/Rhyme'

export default function RhymeCompare() {
  const [currentTags, setCurrentTags] = useState<string[]>([])
  // const [currentAnalysisTags, setCurrentAnalysisTags] = useState<string[]>([])
  const globalTags = useAppSelector((state) => state.compareInfo.globalTags)
  console.log(globalTags, 'compareglobalTags')

  // console.log(globalTags, "compareglobalTags")
  // const analysisGlobalTags = useAppSelector((state) => state.sixLawsInfo.globalTags)
  // console.log(analysisGlobalTags, "analysisglobalTags")

  // 设置画作对比气韵生动-意境（右侧）
  useEffect(() => {
    setCurrentTags(globalTags.意境)
  }, [globalTags.意境])
  // 设置气韵生动-意境（左侧）
  // useEffect(() => {
  //   setCurrentAnalysisTags(analysisGlobalTags.意境)
  // }, [analysisGlobalTags.意境])
  return (
    <div className='compare-rhyme'>
      <Rhyme currentTags={currentTags} />
    </div>
  )
}
